<template>
  <div class="resource-distribution">
    <div class="resource-distribution-top">
        <div class="title">校本资源来源</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
    </div>
    <div class="resource-distribution-content">
        <div style="width: 100%;height: 100%" id="resourceEchartsId"></div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  name: 'resource-distribution',
  data() {
    return {

    }
  },
  methods: {
    initEchart(){
        let dataList = [
            {
                value:1000,
                name:'老师分享',
                number:50
            },
            {
                value:474,
                name:'教研成果',
                number:23.7
            },
            {
                value:526,
                name:'学校建设',
                number:26.3
            },
        ];
        let dom = document.getElementById('resourceEchartsId')
        let myChart = echarts.init(dom)
        let option;
        option = {
            tooltip: {
                trigger: 'item',
                // show: false,
                // 数据的显示方式
                formatter: (param) => {
                    return `${param.data.name}  ${param.data.value}(${param.data.number}%)`
                }
            },
            legend: {
                selectedMode: false, // 是否允许点击
                type: 'scroll',
                orient: 'vertical',

                right: 0,
                top: 70,
                bottom: 0,
                padding: 3, //图例内边距，单位px  5  [5, 10]  [5,10,5,10]
                itemGap: 20, //图例每项之间的间隔
                itemWidth: 9, //图例标记的图形宽度
                itemHeight: 9,
                formatter: (name) => {
                    const data = dataList.find((item)=>{
                        return item.name == name;
                    })
                    return `{name|${name}}{percent|${data.number || 0}%}{count|${data.value || 0}}`;
                },
                textStyle: {
                    rich: {
                        name: {
                            fontSize: 14,
                            verticalAlign: 'right',
                            align: 'left',
                            color:"#7ABFDB",
                            width: 90
                        },
                        percent: {
                            fontSize: 14,
                            align: 'left',
                            color:"#7ABFDB",
                            width: 60
                        },
                        count: {
                            fontSize: 14,
                            color:"#7ABFDB",
                            align: 'left'
                        }
                    },
                    color: '#909399',
                    borderWidth: 2
                },
            },
            series: [
                {
                    name: 'Access From',
                    type: 'pie',
                    // radius: ['40%', '65%'],
                    // center: ['20%', '45%'],
                    radius: ['30%', '55%'],
                    center: ['20%', '50%'],
                    avoidLabelOverlap: false,
                    color: ['#2B7FFF','#27CDE6','#FDBA01','#FF7642','#F35D76','#A470EB','#646BF6','#43AAEC'],
                    label: {
                        show: false,
                        position: 'center',
                        formatter: (data) => {
                            return (
                            "{a|" +
                            data.data.number +
                            "%}" +
                            "\r\n" +
                            "{b|" +
                            data.data.name +
                            "}"
                            );
                        },
                        rich: {
                            a: {
                                fontSize: 16,
                                lineHeight: 20,
                                color: "#fff",
                                align: "center",
                                fontWeight: "bold",
                            },
                            b: {
                                fontSize: 12,
                                lineHeight: 16,
                                fontWeight: "bold",
                                color: "#7ABFDB",
                                align: "center",
                            },
                        },
                        backgroundColor: "transparent",
                        fontWeight: "bold",
                        fontSize: "15",
                        padding: 6,
                    },
                    emphasis: {
                        label: {
                        show: true,
                        fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: dataList
                }
            ]
        };
        option && myChart.setOption(option)
    }
  },
  mounted() {
    this.initEchart();
  },
}
</script>
<style lang="scss" scoped>
.resource-distribution{
    width: 100%;
    height: 300px;
    padding: 0 15px;
    border: 1px solid #053882;
    // background: rgba(6,17,52,0.8);
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 20px;
    .resource-distribution-top{
        position: relative;
        text-align: center;
        margin-bottom: 15px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .resource-distribution-content{
        width: 100%;
        height: 245px;
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
</style>